<template>
  <div class="page-tags">
    <div class="tags-control icon-prev" @click="goHome" style="width: 82px">
      <div :class="['home', this.$route.path === '/main' ? 'active' : '']">
        <span>{{ $t("tags.main") }}</span>
      </div>
    </div>
    <div class="tags-control icon-downs">
      <el-dropdown trigger="hover" @command="commandTags">
        <span class="el-dropdown-link" style="font-size: 18px"><i class="el-icon-arrow-down"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="closeCurrent">{{ $t("tags.current") }}</el-dropdown-item>
          <el-dropdown-item command="closeOther">{{ $t("tags.other") }}</el-dropdown-item>
          <el-dropdown-item command="closeAll">{{ $t("tags.all") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <vue-scroll>
      <div class="tags">
        <div class="tabs__nav" style="transform: translateX(0px)">
          <template v-for="(item, index) in Array.from(visitedViews)">
            <div
              :class="['tabs__item', isActive(item) ? 'active' : '']"
              :key="index"
              v-if="item.path !== '/main' && item.path !== '/bigScreen'"
              @click="go(item.path)"
              @dblclick="reloadView"
            >
              <span>{{ item.name }}</span>
              <span class="el-icon-close" @click.prevent.stop="closeTags(item)"></span>
            </div>
          </template>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
  export default {
    name: "Tags",
    inject: ["reload"],
    data() {
      return {
        tagsWidth: 0,
        tagsTitleWidth: 0,
        tags: ""
      };
    },
    watch: {
      $route(newVal) {
        this.addViewTags();
        const isTags = this.visitedViews.some(item => {
          return item.path === newVal.path;
        });
        if (!isTags) {
          const li = window.document.getElementsByClassName("tags-li");
          for (let i = 0; i < li.length; i++) {
            this.tagsWidth = Number(this.tagsWidth) + Number(li[i].offsetWidth);
          }
        }
      }
    },
    mounted() {
      this.addViewTags();
    },
    methods: {
      go(path) {
        this.$router.push(path);
      },
      goHome() {
        this.$router.push("/main");
      },
      goBigScreen() {
        this.$router.push("/bigScreen");
      },
      generateRoute() {
        if (this.$route.name) {
          return this.$route;
        }
        return false;
      },
      isActive(route) {
        return route.path === this.$route.path;
      },
      addViewTags() {
        const route = this.generateRoute();
        if (!route) {
          return false;
        }
        this.$store.dispatch("addVisitedViews", route);
      },
      // 关闭单个标签
      closeTags(view) {
        this.$store.dispatch("delVisitedViews", view).then(views => {
          if (this.isActive(view)) {
            const item = views.slice(-1)[0];
            if (item) {
              this.$router.push(item.path);
            } else {
              this.$router.push("/main");
            }
          }
        });
      },
      closeCurrent() {
        this.closeTags(this.$route);
      },
      closeOther() {
        this.$store.dispatch("delOthersViews", this.$route);
      },
      closeAll() {
        this.$store.dispatch("delAllViews");
        this.$router.push("/main");
      },
      commandTags(command) {
        switch (command) {
          case "closeCurrent":
            this.closeCurrent();
            break;
          case "closeOther":
            this.closeOther();
            break;
          case "closeAll":
            this.closeAll();
            break;
        }
      },
      reloadView() {
        this.reload();
      }
    },
    computed: {
      collapse() {
        return this.$store.state.collapse;
      },
      visitedViews() {
        return this.$store.state.visitedViews;
      }
    }
  };
</script>

<style lang="scss">
  .page-tags {
    display: flow-root;
    width: 100%;
    position: relative;
    flex-shrink: 0;
    color: var(--vtm-ink-2);
    height: 44px;
    line-height: 44px;
    padding: 0 40px 0 90px;
    background-color: var(--vtm-surface);
    border-bottom: 1px solid var(--vtm-line);
    box-sizing: border-box;
    overflow: hidden;

    .icon-prev {
      left: 0;
      padding: 8px 0;
      .home {
        font-size: 14px;
        font-weight: 600;
        background: var(--vtm-well);
        border-radius: var(--vtm-r-sm);
        margin: 0 10px;
        padding: 0 10px;
        width: 50px;
        height: 28px;
        line-height: 28px;
        transition: background-color var(--vtm-speed) ease, color var(--vtm-speed) ease;
      }

      .home:hover,
      .active {
        background-color: var(--vtm-navy);

        span {
          color: #ffffff;
        }
      }
    }

    .icon-downs {
      right: 0;
      color: var(--vtm-ink-3);
    }

    .tags-control {
      position: absolute;
      top: 0;
      width: 48px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
    }

    .tabs__nav {
      white-space: nowrap;
      position: relative;
      transition: transform 0.3s;
      float: left;
      padding: 8px 0;

      .tabs__item {
        transition: background-color var(--vtm-speed) ease, color var(--vtm-speed) ease;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;

        .el-icon-close {
          position: relative;
          font-size: 12px;
          width: 0;
          height: 14px;
          vertical-align: middle;
          line-height: 15px;
          overflow: hidden;
          top: -1px;
          right: -2px;
          transform-origin: 100% 50%;
        }
      }

      .active {
        background-color: var(--vtm-mint-soft);
        color: var(--vtm-mint-ink);
        font-weight: 600;
      }
    }

    .tabs__item {
      padding: 0 10px 0 15px;
      height: 28px;
      box-sizing: border-box;
      line-height: 28px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: var(--vtm-ink-2);
      position: relative;
      background: var(--vtm-well);
      border-radius: var(--vtm-r-sm);
      margin-right: 10px;

      .el-icon-close {
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        margin-left: 5px;
      }

      .el-icon-close:hover {
        background-color: var(--vtm-crit);
        color: #ffffff;
      }
    }

    .tabs__item:last-child {
      margin-right: 0;
    }

    .tabs__item:hover {
      cursor: pointer;
      background-color: var(--vtm-mint-soft);
      color: var(--vtm-mint-ink);

      .el-icon-close {
        width: 14px;
      }
    }
  }
</style>
